import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GenericService } from './generic.service';

@Injectable({
  providedIn: 'root'
})
export class DescodificadorService extends GenericService {

  constructor(http: HttpClient) {
    super(http, 'descodificacoes');
  }

}
